import React from 'react'
import { getClassNameModern } from '../../../../../../Shared/Frontend/utils/getClassNameFromStyle'
import { IframeBlockClassNames } from './iframeBlock.state'
import { slugify } from '../../../../../../Shared/Frontend/utils/slugify'
import { htmlDecode } from '../../../utils/html'

export const iframeBlockClasses: IframeBlockClassNames = {
  // DEFAULTS
  block: 'block block--iframe',
  inview: 'inview',
  inner: 'block__inner ls-gutter ls-spacing--s',
  header: 'block__header ls-container--nogut',
  label: 'block__label text--s',
  title: 'block__title title--m',
  intro: 'block__intro text--l',
  content: 'block__content ls-container--l-nogut',

  // BLOCK SPECIFIC
}

export const IframeBlockLayout = {
  Inner: (props: {
    id?: string
    children?: React.ReactNode
  }): JSX.Element => {
    const { children, id } = props
    return (
      <div className={getClassNameModern(iframeBlockClasses, 'inner', 'mw-container-s mx-auto px-gutter')}>{children}</div>
    )
  },
  Content: (props: {
    label?: string,
    title?: string,
    intro?: string,
    children?: React.ReactNode
  }) => {
    const {
      label,
      title,
      intro,
      children
    } = props
    return (
      <>
        {(label || title || intro) && (
          <header className={getClassNameModern(iframeBlockClasses, 'header', '')}>
            {label &&
              <p className={getClassNameModern(iframeBlockClasses, 'label', 'fs-6 text-primary text-uppercase')}>{label}</p>
            }
            {title &&
              <h2 id={slugify(htmlDecode(title))} className={getClassNameModern(iframeBlockClasses, 'title', 'h2 mb-3')}>{title}</h2>
            }
            {intro &&
              <div
                className={getClassNameModern(iframeBlockClasses, 'intro', 'text--styled lead mb-3')}
                dangerouslySetInnerHTML={{ __html: intro }}
              />
            }
          </header>
        )}

        <div className={getClassNameModern(iframeBlockClasses, 'content', '')}>{children}</div>
      </>
    )
  }
}
